import { Provider } from '@angular/core';

import { AuthStore } from './auth/auth.store';
import { CreateContractStore } from './create-contract/create-contract.store';
import { EditContractStore } from './edit-contract/edit-contract.store';
import { RootStore } from './root/root.store';

export function provideStorage(): Provider[] {
  return [RootStore, CreateContractStore, AuthStore, EditContractStore];
}
